export default {
	preview: 'Preview',
	'production-order': 'production order',
	'order-result': 'order result',
	
	'production-order-created': 'Production order is created',
	'production-order-updated': 'Production order is updated',
	'order-result-created': 'Order result is created',
	'order-result-updated': 'Order result is updated',
	total: 'Total'
}